import success from '../static/animations/success.json';
import dashboard from '../static/animations/dashboard.json';
import tasklists from '../static/animations/tasklists.json';

const STORE_SLICES = {
  COMMON: 'common',
  AUTHENTICATE: 'authenticate',
  TEAM: 'team',
  SHEETS: 'sheets',
  ONBOARDING: 'onboarding',
  CLOCK: 'clock',
  TASKLISTS: 'tasklists',
  SCHEDULES: 'schedules',
  SETTINGS: 'settings',
  HELP: 'help',
  POS: 'pos',
  ORDERS: 'orders',
  PAYROLL: 'payroll',
  DASHBOARD: 'dashboard',
  COMMISSIONS: 'commissions',
  INVENTORY: 'inventory',
} as const;

const CONTROLLERS = {
  LOGIN: 'login',
  TEAM: 'team',
  COMMON: 'common',
  TIMESHEETS: 'sheets',
  ONBOARDING: 'onboarding',
  CLOCK: 'clock',
  TASKLISTS: 'tasks',
  PERSONNEL: 'admin/personnel',
  SCHEDULES: 'schedules',
  STORAGE: 'storage',
  SETTINGS: 'settings',
  ORDERS: 'orders',
  POS: {
    ORDERS: 'POS/orders',
  },
  INTEGRATIONS: {
    PAYROLL: 'payroll/Integrations',
    DOR: 'integrations/dor',
  },
  DASHBOARD: 'dashboard',
  COMMISSIONS: 'commissions',
  COMMISSIONS_PLANS: {
    ADD: 'add plan',
  },
  INVENTORY: 'inventory',
} as const;

const PERSIST_KEYS = {
  AUTH: 'auth',
  TEAM: 'team',
  COMMON: 'common',
  SHEETS: 'sheets',
  ONBOARDING: 'onboarding',
  CLOCK: 'clock',
  TASKLISTS: 'tasklists',
  SCHEDULES: 'schedules',
  SETTINGS: 'settings',
  HELP: 'help',
  POS: 'pos',
  ORDERS: 'orders',
  PAYROLL: 'payroll',
  DASHBOARD: 'dashboard',
  COMMISSIONS: 'commissions',
  INVENTORY: 'inventory',
} as const;

const PAYMENT_TYPES = {
  Salary: 'Salary',
  'Hourly Wage': 'Hourly Wage',
} as const;

const ANIMATIONS = {
  CHECK_EMAIL: 'https://assets7.lottiefiles.com/packages/lf20_OMBA1g.json',
  SUCCESS: success,
  DASHBOARD: dashboard,
  TASKLISTS: tasklists,
} as const;

const PERMISSIONS_MAP_ID = {
  Employee: 0,
  Manager: 1,
  Admin: 2,
} as const;

const CALCULATION_MAP = {
  team: 0,
  location: 1,
} as const;

const PERMISSIONS = {
  EMPLOYEE: 'Employee',
  ADMIN: 'Admin',
  MANAGER: 'Manager',
} as const;

const COMMISSION_MODEL = {
  split: 0,
  duplicate: 1,
  'team steps': 2,
} as const;

const WAGE = {
  'Hourly Wage': 0,
  Salary: 1,
} as const;

const PERMISSIONS_LOWER = {
  EMPLOYEE: 'employee',
  ADMIN: 'admin',
  MANAGER: 'manager',
} as const;

const QUERY_KEYS = {
  TEAM: 'team',
  TASKLISTS: 'tasklists',
  SUBMISSIONS: 'submissions',
  DAILY_SUBMISSIONS: 'daily',
  SETTINGS: 'settings',
  TIMESHEETS: 'timesheets',
  SCHEDULES: 'schedules',
  ORDERS: {
    GET_ORDERS: 'getOrders',
    GET_ORDERS_COUNT: 'getOrdersCount',
    GET_MAPPING: 'getMapping',
    GET_DAILY_STATES: 'getDailyStates',
    GET_ORDERS_LENGTH: 'getOrdersLength',
  },
  INVENTORY: 'inventory',
  POS: {
    ORDERS: 'pos/orders',
  },
  GUSTO: 'gusto',
  GUSTO_REPORT: 'gusto/report',
  DASHBOARD: {
    YEARLY: 'yearly',
    MONTHLY: 'monthly',
    DAILY: 'daily',
  },
  CLOCK_STATE: 'clockState',
  SHOP_STATE: 'shopState',
  INTEGRATIONS: {
    GET_DOR: 'getDorIntegration',
    GET_DOR_LOCATIONS: 'getDorLocations',
    GET_METRICS: 'getMetrics',
  },
  COMMISSIONS: {
    GET: 'commissions',
    GET_PLANS: 'plans/get',
    GET_TEAMS: 'getTeams',
  },
  PRODUCTS: {
    GET: 'products',
  },
} as const;

const PAGES_ANALYTICS_TITLES = {
  NOT_FOUND: 'ManageMate | Not Found',
  RESET_PASS: 'ManageMate | Reset password',
  REGISTER: 'MangeMate | Register',
  LOGIN: 'ManageMate | Login',
  FORGOT: 'MangeMate | Forgot password',
  CHECK_EMAIL: 'ManageMate | Check email',
  TEAM: 'ManageMate | Team',
  PAYROLL: 'ManageMate | Payroll',
  INVENTORY: 'ManageMate | Inventory',
  ORDERS: 'ManageMate | Orders',
  SCHEDULES: 'ManageMate | Schedules',
  TIMESHEETS: 'ManageMate | Timesheets',
  BULK_MEMBERS: 'ManageMate | Bulk',
  BULK_SHIFTS: 'ManageMate | Bulk shifts',
  TIMESHEETS_CARD: 'ManageMate | Timesheets card',
  ATTRIBUTE: 'ManageMate | Attribute',
  DASHBOARD: 'ManageMate | Dashboard',
  ERROR: 'ManageMate | Error',
  HELP: 'ManageMate | Help',
  SETTINGS: 'ManageMate | Settings',
  TASKLISTS: 'ManageMate | Tasklists',
  COMMISSIONS: 'ManageMate | Commissions',
  COMMISSIONS_TEAMS: 'ManageMate | Commissions teams',
  CREATE_COMMISSION: 'ManageMate | Create commission plan',
  PRICING: 'ManageMate | Pricing',
  COMMISSION_MODEL: 'ManageMate | Commission model',
  TIMEOFF: 'ManageMate | Time off',
  ANALYTICS: {
    COMMISSION: 'ManageMate | Individual commissions Analytics',
    COMMISSION_TEAMS: 'ManageMate | Team commissions Analytics',
    DOR: 'ManageMate | Dor foot Traffic',
  },
} as const;

export {
  STORE_SLICES,
  CONTROLLERS,
  PERSIST_KEYS,
  PAYMENT_TYPES,
  ANIMATIONS,
  PERMISSIONS,
  QUERY_KEYS,
  PAGES_ANALYTICS_TITLES,
  PERMISSIONS_LOWER,
  COMMISSION_MODEL,
  PERMISSIONS_MAP_ID,
  WAGE,
  CALCULATION_MAP,
};
